import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/teacherPayments";

export default {
  async save(entity) {
    return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
  },
};
